import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
    ElementRef,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { config as CONFIG } from "app/app.config";
import { ContratistaService } from "app/main/apps/shared/services/rest/contratista.service";
import { Observable, Subscription } from "rxjs";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import {
    MatAutocomplete,
    MatAutocompleteSelectedEvent,
} from "@angular/material/autocomplete";
import { CodigoDTO } from "app/main/apps/shared/interfaces/codigo.interface";
import { MatChipInputEvent } from "@angular/material/chips";
import { startWith, map } from "rxjs/operators";
import { Comuna } from "app/main/apps/shared/interfaces/comuna.interface";
import { CategoriaDTO } from "app/main/apps/shared/interfaces/categoria.interface";
import { Filtro } from "app/main/apps/shared/interfaces/filtro.interface";
import { FiltroContratista } from "app/main/apps/shared/interfaces/filtro-contratista.interface";
import { FiltrosService } from "app/main/apps/shared/services/util/filtros.service";
import { OnDestroy } from "@angular/core";

@Component({
    selector: "app-filtro-contratistas",
    templateUrl: "./filtro-contratistas.component.html",
    styleUrls: ["./filtro-contratistas.component.scss"],
})
export class FiltroContratistasComponent implements OnInit, OnDestroy {
    @ViewChild("comunaInput") comunaInput: ElementRef<HTMLInputElement>;
    @ViewChild("grupoServicioInput")
    grupoServicioInput: ElementRef<HTMLInputElement>;
    @ViewChild("evaluacionInput") evaluacionInput: ElementRef<HTMLInputElement>;

    @ViewChild("estadoInput") estadoInput: ElementRef<HTMLInputElement>;

    @ViewChild("nombreInput") nombreInput: ElementRef<HTMLInputElement>;
    @ViewChild("rutInput") rutInput: ElementRef<HTMLInputElement>;

    @ViewChild("autoCompleteComuna") matAutocomplete: MatAutocomplete;

    @Input() comunas: Comuna[];
    @Input() grupos: CategoriaDTO[];
    @Input() evaluaciones: Filtro[];
    @Input() estados: Filtro[];

    @Output()
    filtrarContratistas: EventEmitter<FiltroContratista> = new EventEmitter();
    filtros: FiltroContratista;

    config;
    separatorKeysCodes: number[] = [ENTER, COMMA];

    comunaCtrl = new FormControl();
    filteredComunas: Observable<CodigoDTO[]>;

    grupoServicioCtrl = new FormControl();
    filteredGrupos: Observable<CategoriaDTO[]>;

    evaluacionCtrl = new FormControl();
    filteredEvaluaciones: Observable<Filtro[]>;

    estadoCtrl = new FormControl();
    filteredEstados: Observable<any[]>;

    nombreCtrl = new FormControl();

    rutCtrl = new FormControl();
    private subscripciones: Subscription;
    constructor(private _filtroSrvc: FiltrosService) {
        this.subscripciones = new Subscription();
        this.config = CONFIG;
        this.filtros = this._filtroSrvc.getFiltro("filtrosContratista");
        //console.log("filtros", this.filtros);

        this.filteredComunas = this.comunaCtrl.valueChanges.pipe(
            startWith(null),
            map((value: string | null) =>
                value
                    ? this._filter(value, "nombre", this.comunas)
                    : this.comunas.slice()
            )
        );

        this.filteredGrupos = this.grupoServicioCtrl.valueChanges.pipe(
            startWith(null),
            map((value: string | null) =>
                value
                    ? this._filter(value, "descripcion", this.grupos)
                    : this.grupos.slice()
            )
        );

        this.filteredEvaluaciones = this.evaluacionCtrl.valueChanges.pipe(
            startWith(null),
            map((value: string | null) =>
                value
                    ? this._filter(value, "descripcion", this.evaluaciones)
                    : this.evaluaciones.slice()
            )
        );

        this.filteredEstados = this.estadoCtrl.valueChanges.pipe(
            startWith(null),
            map((value: string | null) =>
                value
                    ? this._filter(value, "descripcion", this.estados)
                    : this.estados.slice()
            )
        );
    }

    filtrar() {
        //console.log(this.filtros);
        this.filtrarContratistas.emit(this.filtros);
    }

    ngOnInit(): void {
        this.subscripciones.add(
            this._filtroSrvc.filtrosContratistaLoaded$.subscribe((filtros) => {
                //console.log("filtrosssss", filtros);
                this.filtros = filtros;
            })
        );
    }

    agregarFiltro(
        event: MatChipInputEvent,
        controller: any,
        filtroSeleccionado: string
    ) {
        const input = event.input;
        const value = event.value;

        if ((value || "").trim()) {
            this._filtroSrvc.setFiltro(
                "filtrosContratista",
                filtroSeleccionado,
                value.trim().toLowerCase(),
                value.trim().toLowerCase()
            );
        }

        if (input) {
            input.value = "";
        }

        controller.setValue(null);
    }

    quitarFiltro(nombreFiltro: string) {
        this._filtroSrvc.resetFiltro("filtrosContratista", nombreFiltro);
    }

    seleccionarFiltro(
        event: MatAutocompleteSelectedEvent,
        columnaValor: string,
        columnaDescripcion: string,
        controller: any,
        input: string,
        filtroSeleccionado: string
    ) {
        //console.log(event.option.value);
        const valor = event.option.value[columnaValor];
        const descripcion = event.option.value[columnaDescripcion];

        this._filtroSrvc.setFiltro(
            "filtrosContratista",
            filtroSeleccionado,
            valor,
            descripcion
        );
        this[input].nativeElement.value = "";
        controller.setValue(null);
        this.filtros = this._filtroSrvc.getFiltro("filtrosContratista");
    }

    private _filter(
        value: string | any,
        columnaAFiltrar: string,
        listaDeValoresAfiltrar: any[]
    ): any[] {
        //console.log(value);
        //console.log(columnaAFiltrar);
        let filterValue: string;
        if (typeof value === "object") {
            filterValue = value[columnaAFiltrar].toLowerCase();
        } else {
            filterValue = value.toLowerCase();
        }

        return listaDeValoresAfiltrar.filter((item) =>
            item[columnaAFiltrar].toLowerCase().includes(filterValue)
        );
    }

    limpiarTodosFiltros() {
        this._filtroSrvc.initFiltrosContratista();
        this.filtros = this._filtroSrvc.getFiltro("filtrosContratista");
        this.filtrar();
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
}
